import MoveDownIcon from '@mui/icons-material/MoveDown'
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined'
import { Box, ButtonBase, useTheme } from "@mui/material"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import MEcheckTransferJob from "../../../../components/global/Modals/MEcheckTransferJob"
import ShLabel from "../../../../components/theme/label/ShLabel"
import Heading from "../../../../components/theme/text/Heading"
import Text from "../../../../components/theme/text/Text"
import { useFinishPickingJobMutation, useFullCompletePickingJobMutation, useOpenPickingJobMutation } from "../../../../newapi/pickingjob/pickingjobSlice"
import { tokens } from "../../../../theme"
import { getPickingJobStateData } from "../../../../utils/labelColorText"
import { general_states } from "../../../../utils/staticEnums"
import MConfirmation from '../../../../components/global/Modals/MConfirmation'
import MConfirmEndPickingJob from '../../../../components/global/Modals/MConfirmEndPickingJob'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import HistoryIcon from '@mui/icons-material/History';
import MEcheckPrintJobs from '../../../../components/global/Modals/MEcheckPrintJobs'
import { useSelector } from 'react-redux'
import { selectUserPermission } from '../../../../newapi/user/authentication/authSlice'
import { UserPrivileges } from '../../../../utils/permissions'
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import SidepanelLoader from '../../../../components/theme/sidepanel2/SidepanelLoader'


const SpPickingJobPickingList = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpPickingJobPickingList/SpPickingJobPickingList"));
export const EcheckOrderListHeader = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    const [spLoading, setSpLoading] = useState(false);
    const [isExtended, setIsExtended] = useState(false);

    const [endPickingJob, {isLoading: endPickingJobLoading}] = useFinishPickingJobMutation();
    const [completePickingJob, {isLoading: completePickingJobLoading}] = useFullCompletePickingJobMutation();
    const [openPickingJob, {isLoading: openPickingJobLoading}] = useOpenPickingJobMutation();

    const hasPermission = useSelector((state) => 
        selectUserPermission(state,[UserPrivileges.PICKINGJOB_BULK_ACTION])
    );

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }
    
    const handleClose = (reload) => {
        setAddModalOpen(false);
        if (reload) {
            props.resetScreen();
        }
    };


    const [confirmEndStreamModalOpen, setConfirmEndStreamModalOpen] = useState(false);
    const confirmEndStreamModal = {
        open: confirmEndStreamModalOpen,
        setOpen: setConfirmEndStreamModalOpen,
    };

    const handleConfirmEndStreamClose = () => {
        confirmEndStreamModal.setOpen(false);
    };

    const handleEndStream = async (setPickedToOpen) => {
        if(endPickingJobLoading) return;

        await endPickingJob({ pickingJobId: props.incData.pickingJobId, setPickedToOpen })
        .unwrap()
        .then(res => {
            props.resetScreen();
        })
        .catch(error => {
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    const [confirmCompleteStreamModalOpen, setConfirmCompleteStreamModalOpen] = useState(false);
    const confirmCompleteStreamModal = {
        open: confirmCompleteStreamModalOpen,
        setOpen: setConfirmCompleteStreamModalOpen,
    };

    const handleConfirmCompleteStreamClose = () => {
        confirmCompleteStreamModal.setOpen(false);
    };

    const handleCompleteStream = async () => {
        if(completePickingJobLoading) return;

        await completePickingJob(props.incData.pickingJobId)
        .unwrap()
        .then(res => {
            props.resetScreen();
        })
        .catch(error => {
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    const [confirmOpenStreamModalOpen, setConfirmOpenStreamModalOpen] = useState(false);
    const confirmOpenStreamModal = {
        open: confirmOpenStreamModalOpen,
        setOpen: setConfirmOpenStreamModalOpen,
    };

    const [printJobsModalOpen, setPrintJobsModalOpen] = useState(false);

    const handleConfirmOpenStreamClose = () => {
        confirmOpenStreamModal.setOpen(false);
    };

    const handleOpenStream = async () => {
        if(openPickingJobLoading) return;
        await openPickingJob(props.incData.pickingJobId)
        .unwrap()
        .then(res => {
            props.resetScreen();
        })
        .catch(error => {
            console.log(error);
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }
    
    return (
        <Box
            sx={{

                "@media screen and (max-width: 47.9375em)": { 
                    display: "none" 
                } 
            }}
        >
            <Box
                sx={{
                    display:'flex',
                    alignItems:'center',
                    mb:1,
                }}
            >
                {props.incData?.pickingJobBarcode ?
                <ButtonBase
                    onClick={() => {
                        setSpLoading(true);
                        setIsExtended(true);
                    }}
                    sx={{
                        display:'flex',
                        flexDirection:"column",
                        alignItems:'flex-start',
                        width:1,
                        ml:-1,
                        pl:1,
                        borderTopRightRadius:20,
                        borderBottomRightRadius:20,
                        "&:hover" : {
                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                        }
                    }}
                >
                    <Heading
                        sx={{
                            display:"flex",
                            alignItems:"flex-start",
                            gap:0.5,
                        }}
                    >
                        {props.incData?.pickingJobBarcode}
                        <OpenInNewOutlinedIcon fontSize='small'/>

                    </Heading>
                    <Text>
                        {props.incData?.pickedBy}
                    </Text>
                </ButtonBase>
                : null}
                <ShLabel
                    key={theme.palette.mode}

                    variant={getPickingJobStateData(props.incData?.pickingJobState,theme)?.labelcolor}
                    // variant={getPickingJobStateData(props.incData.pickingJobState,theme)?.labelcolor 
                    //     ?? theme.palette.mode === "dark" ? "greyLight" : "grey"}
                    fitted
                    // borderless={!stateVisibility[state]}
                    size={32}
                    palette="normal"
                    borderless
                    sx={{
                        flexShrink:0,
                        ml:'auto'
                    }}
                >
                    {t(props.incData?.pickingJobState)}
                </ShLabel>
                {(props.incData?.pickingJobState === general_states.IN_PROGRESS  && hasPermission )&& 
                    <>
                        <ButtonBase
                            onClick={() => addModal.setOpen(true)}
                            sx={{
                                ml:1,
                                width:32,
                                height:32,
                                borderRadius:4,
                                color:colors.txt["primary"],
                                textAlign:'center',
                                justifyContent:'center',
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]
                                }
                            }}
                        >
                            <MoveDownIcon/>
                        </ButtonBase>
                        <ButtonBase
                            onClick={async () => {
                               confirmEndStreamModal.setOpen(true);
                            }}
                            sx={{
                                ml:1,
                                width:32,
                                height:32,
                                borderRadius:4,
                                color:colors.red[400],
                                textAlign:'center',
                                justifyContent:'center',
                                "&:hover" : {
                                    background:colors.red[100]
                                }
                            }}
                        >
                            <NotInterestedOutlinedIcon/>
                        </ButtonBase>
                        <ButtonBase
                            onClick={async () => {
                               confirmCompleteStreamModal.setOpen(true);
                            }}
                            sx={{
                                ml:1,
                                width:32,
                                height:32,
                                borderRadius:4,
                                color:colors.green[400],
                                textAlign:'center',
                                justifyContent:'center',
                                "&:hover" : {
                                    background:colors.green[100]
                                }
                            }}
                        >
                            <CheckCircleOutlineIcon/>
                        </ButtonBase>
                    </>
                }

                {(props.incData?.pickingJobState === general_states.FULLYPICKED && hasPermission) && 
                        <ButtonBase
                            onClick={async () => {
                               confirmOpenStreamModal.setOpen(true);
                            }}
                            sx={{
                                ml:1,
                                width:32,
                                height:32,
                                borderRadius:4,
                                color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                textAlign:'center',
                                justifyContent:'center',
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100]
                                }
                            }}
                        >
                            <LockOpenIcon/>
                        </ButtonBase>
                }
                {props.incData?.pickingJobId &&
                        <ButtonBase
                            onClick={() => setPrintJobsModalOpen(true)}
                            title={t("print_jobs")}
                            sx={{
                                ml:1,
                                width:32,
                                height:32,
                                borderRadius:4,
                                color:colors.txt["primary"],
                                textAlign:'center',
                                justifyContent:'center',
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]
                                }
                            }}
                        >
                            <HistoryIcon/>
                        </ButtonBase>
                }
            </Box>

            <MEcheckTransferJob
                onOpen={() => addModal.setOpen(true)} 
                onClose={() => addModal.setOpen(false)} 
                open={addModal.open} 
                handleClose={handleClose}
                barcode={props.incData?.pickingJobBarcode}
            />
            <MConfirmEndPickingJob
                open={confirmEndStreamModal.open}
                handleClose={handleConfirmEndStreamClose}
                title={t("stop_pickingjob_title")}
                subtitle={t("stop_pickingjob_subtitle")}
                confirm={(setPickedToOpen) => handleEndStream(setPickedToOpen)}
            />
            <MConfirmation
                open={confirmCompleteStreamModal.open}
                handleClose={handleConfirmCompleteStreamClose}
                title={t("complete_pickingjob_title")}
                subtitle={t("complete_pickingjob_subtitle")}
                confirm={() => handleCompleteStream(true)}
            />

            <MConfirmation
                open={confirmOpenStreamModal.open}
                handleClose={handleConfirmOpenStreamClose}
                title={t("open_pickingjob_title")}
                subtitle={t("open_pickingjob_subtitle")}
                confirm={() => handleOpenStream(true)}
            />

            <MEcheckPrintJobs
                open={printJobsModalOpen}
                handleClose={() => setPrintJobsModalOpen(false)}
                pickingJobId={props.incData?.pickingJobId}
            />

            {spLoading && 
                <SpPickingJobPickingList
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    pickingJobListId={props.incData?.pickingJobId}
                    // data={streamData} 
                /> 
            }
        </Box>
    )
}